import { ProtectedRoute, Role } from '@shared/auth';
import { Outlet } from 'react-router';

const AdminLayout = () => {
  return <ProtectedRoute component={Outlet} roles={[Role.Administrator]}/>;
};

export default AdminLayout;
